export const daylightThemeId = "daylight" as const;
export const themeStorageKey = "daylight.visual-theme";

export const themeOptions = [
  { id: daylightThemeId, label: "Daylight", colorScheme: "light" },
  { id: "windows-light", label: "Windows Light", colorScheme: "light" },
  { id: "windows-dark", label: "Windows Dark", colorScheme: "dark" },
  {
    id: "windows-spotlight",
    label: "Windows Spotlight",
    colorScheme: "light",
  },
  { id: "glow", label: "Glow", colorScheme: "dark" },
  { id: "captured-motion", label: "Captured Motion", colorScheme: "dark" },
  { id: "sunrise", label: "Sunrise", colorScheme: "light" },
  { id: "flow", label: "Flow", colorScheme: "light" },
] as const;

export type ThemeId = (typeof themeOptions)[number]["id"];

type ThemeStorage = Pick<Storage, "getItem" | "setItem">;
type ThemeRoot = Pick<HTMLElement, "dataset" | "style">;

function isThemeId(value: string | null): value is ThemeId {
  return themeOptions.some((theme) => theme.id === value);
}

export function readStoredTheme(storage: ThemeStorage): ThemeId {
  try {
    const stored = storage.getItem(themeStorageKey);
    return isThemeId(stored) ? stored : daylightThemeId;
  } catch {
    return daylightThemeId;
  }
}

export function storeTheme(theme: ThemeId, storage: ThemeStorage) {
  try {
    storage.setItem(themeStorageKey, theme);
  } catch {
    // The visual choice still applies for this page when storage is blocked.
  }
}

export function applyTheme(theme: ThemeId, root: ThemeRoot) {
  root.dataset.theme = theme;
  root.style.colorScheme =
    themeOptions.find((option) => option.id === theme)?.colorScheme ?? "light";
}
